import { BALL, BALL_TYPE_LIST, DETAILS, OVER, PARTNERSHIP, PLAYER, TEAM, WICKET, WICKET_TYPE_LIST } from "../../Pages/Commentary/CommentartConst";
import { DATE_TIME_PICKER, MULTI_SELECT, SELECT, TEXT, SWITCH, COUNTER } from "../../components/Common/Const";

export const MatchDetailFields = [
  {
    name: "eventTypeId",
    label: "Event Type",
    options: [{ label: "Select a Event Type", value: "0" }],
    defaultValue: "0",
    type: SELECT,
    isRequired: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "competitionId",
    label: "Competition Type",
    options: [{ label: "Select a Competition Type", value: "0" }],
    defaultValue: "0",
    type: SELECT,
    isRequired: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "eventId",
    label: "Event",
    options: [{ label: "Select a Event", value: "0" }],
    defaultValue: "0",
    type: SELECT,
    isRequired: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "matchTypeId",
    label: "Match Type",
    options: [{ label: "Select a Match Type", value: "0" }],
    defaultValue: "0",
    type: SELECT,
    isRequired: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "eventRefId",
    label: "Event Ref Id",
    defaultValueDepends: "",
    isRequired: false,
    regex: /^.{0,100}$/,
    regexErrorMessage: "Max allowed Characters 100",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: TEXT,
  },
  {
    name: "eventDate",
    label: "Event Date",
    isRequired: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: DATE_TIME_PICKER,
  },
  {
    name: "eventName",
    label: "Event Name",
    isRequired: true,
    regex: /^.{0,500}$/,
    regexErrorMessage: "Max allowed Characters 500",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: TEXT,
  },
  {
    name: "eventNo",
    label: "Event No",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: TEXT,
  },
  
  
  // {
  //     name: "displayStatus",
  //     label: "Display Status",
  //     labelColspan: { xs: 12, md: 2, lg: 2 },
  //     fieldColspan: { xs: 12, md: 4, lg: 4 },
  //     regex: /^[^']{1,100}$/,
  //     regexErrorMessage: "Max allowed Characters 20, No Spacial Character",
  //     type: TEXT,
  // },
  {
    name: "onfieldUmpires",
    label: "On Field Umpires",
    // isRequired: true,
    // defaultValue: 5,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: TEXT,
  },
  {
    name: "thirdUmpire",
    label: "Thirds Umpires",
    // isRequired: true,
    // defaultValue: 5,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: TEXT,
  },
  {
    name: "matchReferee",
    label: "Match Referee",
    // isRequired: true,
    // defaultValue: 5,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: TEXT,
  },
//   {
//     name: "tpId",
//     label: "TPID",
//     type: TEXT,
//     labelColspan: { xs: 12, md: 2, lg: 2 },
//     fieldColspan: { xs: 12, md: 4, lg: 4 },
//   },
  // {
  //     name: "isCountInPoint",
  //     label: "Is Count In Point",
  //     defaultValue: true,
  //     labelColspan: { xs: 12, md: 2, lg: 2 },
  //     fieldColspan: { xs: 12, md: 4, lg: 4 },
  //     type: SWITCH,
  // },
//   {
//     name: "isClientShow",
//     label: "Client Show",
//     defaultValue: false,
//     labelColspan: { xs: 12, md: 2, lg: 2 },
//     fieldColspan: { xs: 12, md: 4, lg: 4 },
//     type: SWITCH,
//   },
  {
    name: "isActive",
    label: "Active",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: SWITCH,
  },
//   {
//     name: "isTest",
//     label: "Test",
//     defaultValue: false,
//     labelColspan: { xs: 12, md: 2, lg: 2 },
//     fieldColspan: { xs: 12, md: 4, lg: 4 },
//     type: SWITCH,
//   },
//   {
//     name: "isVirtual",
//     label: "Virtual",
//     defaultValue: false,
//     labelColspan: { xs: 12, md: 2, lg: 2 },
//     fieldColspan: { xs: 12, md: 4, lg: 4 },
//     type: SWITCH,
//   },
];
export const ExtraInfoFields = [
    {
    name: "pythonId",
    label: "Algo",
    options: [{ label: "Select a Python Type", value: "0" }],
    isRequired: true,
    defaultValue: "0",
    type: SELECT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "delay",
    label: "Event Delay",
    isRequired: true,
    defaultValue: 4,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: TEXT,
  },
  {
    name: "scoringType",
    label: "Scoring Type",
    isRequired: true,
    defaultValue: 1,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: SELECT,
    options: [
        { label: "Select Score Type", value: "0" },
        { label: "manual", value: 1 },
        { label: "Entity", value: 2 },
      ],
  },
  {
    name: "tpId",
    label: "TPID",
    dependsOnField: "scoringType",
    dependsOnValue: 2,
    isRequired: true,
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "streamingType",
    label: "Streaming Type",
    defaultValue: 1,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: SELECT,
    options: [
        { label: "Select Streaming Type", value: "0" },
        { label: "URL", value: 1 },
        { label: "Streams", value: 2 },
      ],
  },
//   {
//     name: "Stream List",
//     label: " ",
//     type: IFRAME_BUTTON,
//     dependsOnField: "streamingType",
//     dependsOnValue: 2,
//     labelColspan: { xs: 12, md: 2, lg: 2 },
//     fieldColspan: { xs: 12, md: 4, lg: 4 },
//   },
  {
    name: "streamingUrl",
    label: "Streaming Url",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "isPredictMarket",
    label: "Predict Market",
    // dependsOnField: 'eventId',
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: SWITCH,
  },

  {
    name: "isClientShow",
    label: "Client Show",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: SWITCH,
  },
  {
    name: "isTest",
    label: "Test",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: SWITCH,
  },
  {
    name: "isVirtual",
    label: "Virtual",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: SWITCH,
  },
];

export const TeamDetailsFields = [
    {
        name: "team1Id",
        label: "Team",
        type: SELECT,
        defaultValue: "0",
        onchangeApi: true,
        isRequired: true,
        options: [{ label: "Select Team", value: "0" }],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "team2Id",
        label: "Co. Team",
        options: [{ label: "Select Team", value: "0" }],
        defaultValue: "0",
        onchangeApi: true,
        isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "team1Captain",
        label: "Team Captain",
        options: [{ label: "Select Captain", value: "0" }],
        defaultValue: "0",
        // isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "team2Captain",
        label: "Co. Team Captain",
        type: SELECT,
        // isRequired: true,
        options: [{ label: "Select Captain", value: "0" }],
        defaultValue: "0",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "team1Kipper",
        label: "Team Keeper",
        options: [{ label: "Select Keeper", value: "0" }],
        defaultValue: "0",
        // isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "team2Kipper",
        label: "Co. Team Keeper",
        options: [{ label: "Select Keeper", value: "0" }],
        defaultValue: "0",
        // isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "team1Players",
        label: "Select Players",
        options: [],
        showSelectAll: true,
        // isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: MULTI_SELECT,
    },
    {
        name: "team2Players",
        label: "Select Players",
        options: [],
        showSelectAll: true,
        // isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: MULTI_SELECT,
    },
    {
        name: "addSystemPlayer",
        label: "Is System Players",
        defaultValue: false,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 1, lg: 1 },
        type: SWITCH,
    },
    {
        name: "systemPlayerCount",
        label: false,
        dependsOnField: "addSystemPlayer",
        dependsOnValue: true,
        defaultValue: 1,
        type: COUNTER,
        className: "no-spinners",
        min: 0,
        max: 11,
        step: 1,
        requiredErrorMessage: "Please enter value",
        fieldColspan: { xs: 12, md: 3, lg: 3 }
    },
    {
        type: TEXT,
        name: "drsCount",
        label: "Drs Count",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "isCountInPoint",
        label: "Is Count In Point",
        defaultValue: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SWITCH,
    },
]

export const WeatherDetailsFields = [
    {
        type: SELECT,
        name: "countryId",
        label: "Country",
        parentclassName: "",
        options: [{ label: "Select a Country", value: "0" }],
        defaultValue: "0",
        // regex: /^[^']{1,100}$/,
        // regexErrorMessage: "Max allowed Characters 100, No Spacial(') Character",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "venueId",
        label: "Location",
        regex: /^.{0,100}$/,
        options: [{ label: "Select a Location", value: "0" }],
        defaultValue: "0",
        // regexErrorMessage: "Max allowed Characters 100",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
        // options: [],
    },
    {
        name: "weatherCondition",
        label: "Weather Condition",
        // isRequired: true,
        defaultValue: "",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    {
        name: "description",
        label: "Description",
        // isRequired: true,
        defaultValue: "",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    {
        name: "temp",
        label: "Temperature",
        // isRequired: true,
        // defaultValue: 22.33,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: COUNTER,
    },
    {
        name: "humidity",
        label: "Humidity",
        // isRequired: true,
        // defaultValue: 70,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: COUNTER,
    },
    {
        name: "visibility",
        label: "Visibility",
        // isRequired: true,
        // defaultValue: 900,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: COUNTER,
    },
    {
        name: "windSpeed",
        label: "Wind Speed",
        // isRequired: true,
        // defaultValue: 34.5,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: COUNTER,
    },
    {
        name: "clouds",
        label: "Clouds",
        // isRequired: true,
        // defaultValue: 43,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: COUNTER,
    },
    
    {
        name: "weather",
        label: "Weather",
        defaultValue: "0",
        options: [
        { label: "Select Weather", value: "0" },
        { label: "RANDOM", value: 1 },
        { label: "COLD", value: 2 },
        { label: "WARM", value: 3 },
        { label: "HOT", value: 4 },
        { label: "MILD", value: 5 },
        // { label: "Select Weather", value: "0" },
        // { label: "Sunny", value: "1" },
        // { label: "Cloudy", value: "2" },
        // { label: "Rainy", value: "3" },
        // { label: "Drizzling", value: "4" },
        // { label: "Showers", value: "5" },
        // { label: "Humid", value: "6" },
        // { label: "Hot", value: "7" },
        // { label: "Windy", value: "8" },
        // { label: "Wet", value: "9" },
        ],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
]
export const PitchDetailsFields = [
    {
        name: "pitchCondition",
        label: "Pitch Condition",
        // isRequired: true,
        defaultValue: "",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    {
        name: "battingCondition",
        label: "Batting Condition",
        // isRequired: true,
        defaultValue: "",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    {
        name: "paceBowlingCondition",
        label: "Pace Bowling Condition",
        // isRequired: true,
        defaultValue: "",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    {
        name: "spineBowlingConniton",
        label: "Spin Bowling Condition",
        // isRequired: true,
        defaultValue: "",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    {
        name: "pitchType",
        label: "Pitch Type",
        defaultValue: "0",
        options: [
        { label: "Select Pitch Type", value: "0" },
        { label: "Dry", value: 1 },
        { label: "Grassy/Dusty", value: 2 },
        { label: "Grassy/Dry", value: 3 },
        { label: "Grassy", value: 4 },
        { label: "Dusty", value: 5 },
        { label: "Standard", value: 6 },
        ],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "pitchCracks",
        label: "Pitch Cracks",
        defaultValue: "0",
        options: [
        { label: "Select Pitch Cracks", value: "0" },
        { label: "NONE", value: 1 },
        { label: "LIGHT", value: 2 },
        { label: "HEAVY", value: 3 },
        // { label: "Select Pitch", value: "0" },
        // { label: "Hard", value: "1" },
        // { label: "Wet", value: "2" },
        // { label: "Damp", value: "3" },
        // { label: "Green", value: "4" },
        // { label: "Cracked", value: "5" },
        // { label: "Dry", value: "6" },
        // { label: "Patch", value: "7" },
        ],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "pitchHardness",
        label: "Pitch Hardness",
        defaultValue: "0",
        options: [
        { label: "Select Pitch Hardness", value: "0" },
        { label: "SOFT", value: 1 },
        { label: "VERYSOFT", value: 2 },
        { label: "HARD", value: 3 },
        { label: "MEDIUM", value: 4 },
        ],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "pitchWareSpeed",
        label: "Pitch Ware Speed",
        defaultValue: "0",
        options: [
        { label: "Select Pitch Ware Speed", value: "0" },
        { label: "NORMAL", value: 1 },
        { label: "SLOW", value: 2 },
        { label: "FAST", value: 3 },
        ],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "pitchAge",
        label: "Pitch Age",
        defaultValue: 1,
        options: [
        { label: "Select Pitch Age", value: "0" },
        { label: "Day 1", value: 1 },
        { label: "Day 2", value: 2 },
        { label: "Day 3", value: 3 },
        { label: "Day 4", value: 4 },
        { label: "Day 5", value: 5 },
        ],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
    {
        name: "session",
        label: "Session",
        // isRequired: true,
        defaultValue: 1,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    {
        name: "difficulty",
        label: "Difficulty",
        options: [{ label: "Select Difficulty", value: "0" }],
        defaultValue: "0",
        type: SELECT,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "lawnStriping",
        label: "Lawn Striping",
        defaultValue: "0",
        options: [
        { label: "Select Lawn Striping", value: "0" },
        { label: "Cross hatch", value: 1 },
        { label: "Stripe", value: 2 },
        { label: "Vertical", value: 3 },
        { label: "None", value: 4 },
        { label: "Diamond", value: 5 },
        ],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: SELECT,
    },
]

export const SHORT_COMMENTARY_TEAM = [
    {
        name: "teamScore",
        placeholder: "Score",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamWicket",
        placeholder: "Wicket",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamOver",
        placeholder: "Over",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamStatus",
        placeholder: "Status",
        formName: TEAM,
        type: SELECT,
        defaultValue: 1,
        options: [
            { label: "Batting", value: 1 },
            { label: "Bowling", value: 2 },
        ],
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamTrialRuns",
        placeholder: "Trial",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamLeadRuns",
        placeholder: "Lead",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamWideRuns",
        placeholder: "Wide",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamByRuns",
        placeholder: "By",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamLegByRuns",
        placeholder: "Leg Bye",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "teamNoBallRuns",
        placeholder: "No Ball",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },

]

export const SHORT_COMMENTARY_BATTING_PLAYER = [
    {
        name: "batRun",
        placeholder: "Runs",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 3 },

    },
    {
        name: "batBall",
        placeholder: "Balls",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 3 },

    },
    {
        name: "batFour",
        placeholder: "Four",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "batSix",
        placeholder: "Six",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "batterOrder",
        placeholder: "Order",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
]

export const SHORT_COMMENTARY_BOWLING_PLAYER = [
    {
        name: "bowlerOver",
        placeholder: "Over",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },
    },
    {
        name: "bowlerCurrentBall",
        placeholder: "Current Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerTotalBall",
        placeholder: "Total Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerRun",
        placeholder: "Runs",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerDotBall",
        placeholder: "Dot Balls",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerMaidenOver",
        placeholder: "Maiden Over",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerFour",
        placeholder: "Four",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerSix",
        placeholder: "Six",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerWideBall",
        placeholder: "Wide Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerWideBallRun",
        placeholder: "Wide Ball Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerNoBall",
        placeholder: "No Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerNoBallRun",
        placeholder: "No Ball Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerByeBall",
        placeholder: "Bye Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerByeBallRun",
        placeholder: "Bye Ball Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerLegByeBall",
        placeholder: "Leg Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerLegByeBallRun",
        placeholder: "Leg Ball Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerTotalWicket",
        placeholder: "Wickets",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
    {
        name: "bowlerOrder",
        placeholder: "Bowler Order",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 4, lg: 2 },

    },
]

export const BALL_FEATURE_FIELDS = (battingPlayers = []) => [
    {
        name: "batStrikeId",
        placeholder: "Strike",
        formName: BALL,
        type: SELECT,
        options: battingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "currentOverBalls",
        placeholder: "B-Count",
        formName: BALL,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "ballType",
        placeholder: "B-Type",
        type: SELECT,
        formName: BALL,
        defaultValue: 0,
        options: BALL_TYPE_LIST,
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "teamScore",
        placeholder: "Score",
        formName: BALL,
        type: TEXT,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "ballRun",
        placeholder: "Run",
        formName: BALL,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "ballFour",
        placeholder: "4",
        formName: BALL,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 1, lg: 1 },
    },
    {
        name: "ballSix",
        placeholder: "6",
        formName: BALL,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 1, lg: 1 },
    },
    {
        name: "ballExtraRun",
        placeholder: "Extra",
        formName: BALL,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamWicket",
        placeholder: "Wicket",
        formName: BALL,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "ballIsWicket",
        placeholder: "Wicket",
        formName: BALL,
        type: SWITCH,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "ballIsBoundry",
        placeholder: "Boundry",
        formName: BALL,
        type: SWITCH,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "ballIsDot",
        placeholder: "B-Dot",
        formName: BALL,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "ballIsCount",
        placeholder: "B-Count",
        formName: BALL,
        type: SWITCH,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
]

export const COMMENTARY_DETAILS_FIELDS = (teamlist = []) => [
    // {
    //     name: "tossWonBy",
    //     placeholder: "Toss Won",
    //     formName: DETAILS,
    //     type: SELECT,
    //     options: teamlist?.map(p => ({
    //         value: p?.teamId,
    //         label: p?.teamName
    //     })),
    //     className: "no-spinners",
    //     fieldColspan: { xs: 3, md: 2, lg: 2 },
    // },
    // {
    //     name: "choseTo",
    //     placeholder: "Chose To",
    //     type: SELECT,
    //     formName: TEAM,
    //     options: [
    //         { label: "Batting", value: 1 },
    //         { label: "Bowling", value: 2 },
    //     ],
    //     className: "no-spinners",
    //     fieldColspan: { xs: 3, md: 2, lg: 2 },
    // },
    {
        name: "rmk",
        placeholder: "Rmk",
        formName: DETAILS,
        type: TEXT,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "displayStatus",
        placeholder: "Display Status",
        formName: DETAILS,
        type: TEXT,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "winnerId",
        placeholder: "Winner",
        formName: DETAILS,
        type: SELECT,
        options: teamlist?.map(p => ({
            value: p?.teamId,
            label: p?.teamName
        })),
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "tossRmk",
        placeholder: "Toss Rmk",
        formName: DETAILS,
        type: TEXT,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "winRmk",
        placeholder: "Win Rmk",
        formName: DETAILS,
        type: TEXT,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
]

export const TEAM_FEATURE_FIELDS = [
    {
        name: "teamStatus",
        placeholder: "Status",
        type: SELECT,
        defaultValue: 1,
        formName: TEAM,
        options: [
            { label: "Batting", value: 1 },
            { label: "Bowling", value: 2 },
        ],
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "currentInnings",
        placeholder: "C Innings",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamBattingOrder",
        placeholder: "Batting Order",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamScore",
        placeholder: "Score",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamOver",
        placeholder: "Over",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamWicket",
        placeholder: "Wicket",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamWideRuns",
        placeholder: "Wide",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamNoBallRuns",
        placeholder: "No Ball",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamByRuns",
        placeholder: "Bye",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamLegByRuns",
        placeholder: "Leg Bye",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamPenaltyRuns",
        placeholder: "Penalty",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamTrialRuns",
        placeholder: "Trial",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamLeadRuns",
        placeholder: "Lead",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamMaxOver",
        placeholder: "Max overs",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "drsCount",
        placeholder: "Drs Count",
        formName: TEAM,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    // {
    //     name: "tpId",
    //     placeholder: "TpId",
    //     formName: TEAM,
    //     type: COUNTER,
    //     className: "no-spinners",
    //     fieldColspan: { xs: 3, md: 2, lg: 1 },
    // },
    {
        name: "isBattingComplete",
        placeholder: "Batting Complete",
        formName: TEAM,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
]

export const OVER_FEATURE_FIELD = (bowlingPlayers = [], teamlist = [], overTypeList = []) => [
    {
        name: "bowlerId",
        placeholder: "Bowler",
        formName: OVER,
        type: SELECT,
        options: bowlingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "teamId",
        placeholder: "Team",
        formName: OVER,
        type: SELECT,
        options: teamlist?.map(p => ({
            value: p?.teamId,
            label: p?.teamName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "overType",
        placeholder: "Over Type",
        formName: OVER,
        type: SELECT,
        options: overTypeList?.map(p => ({
            value: p?.id,
            label: p?.overType
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "ballCount",
        placeholder: "B-Count",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "teamScore",
        placeholder: "Score",
        formName: OVER,
        type: TEXT,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalRun",
        placeholder: "Runs",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalFour",
        placeholder: "4s",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalSix",
        placeholder: "6s",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalWideBall",
        placeholder: "WD Ball",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalWideRun",
        placeholder: "WD Runs",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalNoball",
        placeholder: "NB Ball",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalNoBallRun",
        placeholder: "No Runs",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalByesRun",
        placeholder: "B Runs",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalLegByesRun",
        placeholder: "LB Runs",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
     {
        name: "totalPanelty",
        placeholder: "Penalty",
        formName: OVER,
        type: COUNTER,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "totalWicket",
        placeholder: "Wicket",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "dotBall",
        placeholder: "Dot Balls",
        formName: OVER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "isMaiden",
        placeholder: "Maiden",
        formName: OVER,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "isComplete",
        placeholder: "Complete",
        formName: OVER,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
]

export const WICKET_FEATURE_FIELD = (battingPlayers = [], bowlingPlayers = [], overList = []) => [
    {
        name: "overId",
        placeholder: "Over",
        formName: WICKET,
        type: SELECT,
        options: overList?.map(p => ({
            value: p?.overId,
            label: p?.over + 1
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "overCount",
        placeholder: "O-Count",
        formName: WICKET,
        type: COUNTER,
        fieldColspan: { xs: 3, md: 2, lg: 4 },
    },
    {
        name: "ballCount",
        placeholder: "B-Count",
        formName: WICKET,
        type: COUNTER,
        fieldColspan: { xs: 3, md: 2, lg: 4 },
    },
    {
        name: "batterId",
        placeholder: "Batter",
        formName: WICKET,
        type: SELECT,
        options: battingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "playerRun",
        placeholder: "Runs",
        formName: WICKET,
        type: COUNTER,
        fieldColspan: { xs: 3, md: 2, lg: 4 },
    },
    {
        name: "playerBalls",
        placeholder: "Balls",
        formName: WICKET,
        type: COUNTER,
        fieldColspan: { xs: 3, md: 2, lg: 4 },
    },
    {
        name: "teamScore",
        placeholder: "Score",
        formName: WICKET,
        type: COUNTER,
        fieldColspan: { xs: 3, md: 2, lg: 4 },
    },
    {
        name: "wicketCount",
        placeholder: "Wicket",
        formName: WICKET,
        type: COUNTER,
        fieldColspan: { xs: 3, md: 2, lg: 4 },
    },
    {
        name: "wicketType",
        placeholder: "Wicket Type",
        formName: WICKET,
        type: SELECT,
        defaultValue: 1,
        options: WICKET_TYPE_LIST,
        fieldColspan: { xs: 3, md: 4, lg: 3 },
    },
    {
        name: "bowlerId",
        placeholder: "Bowler",
        formName: WICKET,
        type: SELECT,
        options: bowlingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "fieldPlayerId",
        placeholder: "Field Player",
        formName: WICKET,
        type: SELECT,
        options: bowlingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "fieldPlayer2Id",
        placeholder: "Field Player2",
        formName: WICKET,
        type: SELECT,
        options: bowlingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
]

export const PARTNERSHIP_FEATURE_FIELD = (battingPlayers = [], ballList = []) => [
    {
        name: "commentaryBallByBallId",
        placeholder: "BallByBall",
        formName: PARTNERSHIP,
        type: SELECT,
        options: ballList?.map(p => ({
            value: p?.commentaryBallByBallId,
            label: parseFloat(p?.overCount || 0).toFixed(1)
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "order",
        placeholder: "Order",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "batter1Id",
        placeholder: "Batter 1",
        formName: PARTNERSHIP,
        type: SELECT,
        options: battingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "batter1Runs",
        placeholder: "Batter1 Runs",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "batter1Balls",
        placeholder: "Batter1 Balls",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "batter2Id",
        placeholder: "Batter 2",
        formName: PARTNERSHIP,
        type: SELECT,
        options: battingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "batter2Runs",
        placeholder: "Batter2 Runs",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "batter2Balls",
        placeholder: "Batter2 Balls",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "totalRuns",
        placeholder: "Runs",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "totalBalls",
        placeholder: "Balls",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "totalFour",
        placeholder: "4s",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "totalSix",
        placeholder: "6s",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "totalWide",
        placeholder: "Wide",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "totalNoBall",
        placeholder: "No-Ball",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "extras",
        placeholder: "Extras",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
    {
        name: "totalExtra",
        placeholder: "Total Extra",
        formName: PARTNERSHIP,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 2 },
    },
]

export const BATTING_PLAYER_FEATURE_FIELD = (bowlingPlayers = []) => [
    {
        name: "playerName",
        placeholder: "Name",
        formName: PLAYER,
        type: TEXT,
        isDisable: true,
        fieldColspan: { xs: 4, md: 3, lg: 2 },
    },
    {
        name: "batterOrder",
        placeholder: "Order",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "batRun",
        placeholder: "Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "batBall",
        placeholder: "Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "batFour",
        placeholder: "4s",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "batSix",
        placeholder: "6s",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "batDotBall",
        placeholder: "Dot Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "batSrr",
        placeholder: "Srr",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "batsmanAverage",
        placeholder: "Average",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "batsmanStrikeRate",
        placeholder: "Strike Rate",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "wicketType",
        placeholder: "Wicket Type",
        formName: PLAYER,
        type: SELECT,
        options: WICKET_TYPE_LIST,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "fielderId1",
        placeholder: "Fielder 1",
        formName: PLAYER,
        type: SELECT,
        options: bowlingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "fielderId2",
        placeholder: "Fielder 2",
        formName: PLAYER,
        type: SELECT,
        options: bowlingPlayers?.map(p => ({
            value: p?.commentaryPlayerId,
            label: p?.playerName
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "isBatterOut",
        placeholder: "Batter Out",
        formName: PLAYER,
        type: SWITCH,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "isBatterRetir",
        placeholder: "Batter Retire",
        formName: PLAYER,
        type: SWITCH,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "isPlay",
        placeholder: "Play",
        formName: PLAYER,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "onStrike",
        placeholder: "On Strike",
        formName: PLAYER,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "isPlayInEvent",
        placeholder: "Play In Event",
        formName: PLAYER,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
]

export const BOWLING_PLAYER_FEATURE_FIELD = (bowlingStyleList = []) => [
    {
        name: "playerName",
        placeholder: "Name",
        formName: PLAYER,
        type: TEXT,
        isDisable: true,
        fieldColspan: { xs: 4, md: 3, lg: 2 },
    },
    {
        name: "bowlingStyle",
        placeholder: "Bowling Style",
        formName: PLAYER,
        type: SELECT,
        options: bowlingStyleList?.map(p => ({
            value: p?.bowlingTypeId,
            label: p?.bowlingType
        })),
        fieldColspan: { xs: 4, md: 3, lg: 3 },
    },
    {
        name: "bowlerOrder",
        placeholder: "Order",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerOver",
        placeholder: "Over",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerCurrentBall",
        placeholder: "Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerRun",
        placeholder: "Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerMaidenOver",
        placeholder: "Maiden",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerTotalBall",
        placeholder: "T-Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerTotalWicket",
        placeholder: "Wicket",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerDotBall",
        placeholder: "Dot Ball",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerEconomy",
        placeholder: "Eco",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerAverage",
        placeholder: "Avg",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerFour",
        placeholder: "4s",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerSix",
        placeholder: "6s",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerWideBall",
        placeholder: "WD",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerNoBall",
        placeholder: "NB",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerByeBall",
        placeholder: "Bye",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerLegByeBall",
        placeholder: "L-Bye",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerWideBallRun",
        placeholder: "Wide Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerNoBallRun",
        placeholder: "No Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerByeBallRun",
        placeholder: "Bye Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerLegByeBallRun",
        placeholder: "L-Bye Run",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "bowlerPeneltyRun",
        placeholder: "Penalty",
        formName: PLAYER,
        type: COUNTER,
        className: "no-spinners",
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "isPlay",
        placeholder: "Play",
        formName: PLAYER,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
    {
        name: "isPlayInEvent",
        placeholder: "Play In Event",
        formName: PLAYER,
        type: SWITCH,
        fieldColspan: { xs: 3, md: 2, lg: 1 },
    },
]